import React from 'react';
import { Skeleton } from "../../../../entities/message/ui";
import { cnBem } from "../../../../shared/lib";
import styles from "./styles.pcss";
var cnSkeletonList = cnBem('skeleton-list', styles);
export var SkeletonList = function SkeletonList() {
  return /*#__PURE__*/React.createElement("div", {
    className: cnSkeletonList()
  }, Array.from({
    length: 10
  }).map(function (_, i) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      key: i,
      side: i % 2 === 0 ? 'main' : 'opposite'
    });
  }));
};